import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider, useRouteError } from 'react-router-dom';
import {
  AppQueryProvider,
  ApplicationErrorBoundary,
  ApplicationErrorScreen,
  AuthProvider,
  PermissionProvider,
  ToastProvider,
} from '@beatq/shared';
import { ThemeProvider } from '@beatq/ui';
import '@beatq/ui/styles.css';
import './styles/merchant-ops.css';
import './styles/onboarding.css';
import './styles/merchant-design.css';
import './styles/merchant-workspace.css';
import './styles/merchant-order-workspace.css';
import './styles/onboarding-premium.css';
import './styles/onboarding-refinement.css';
import { App } from './App.js';

function MerchantRouteError() {
  return (
    <ApplicationErrorScreen
      appName="BeatQ Merchant"
      error={useRouteError()}
      homeHref="/operations"
    />
  );
}

const router = createBrowserRouter([
  { path: '*', element: <App />, errorElement: <MerchantRouteError /> },
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ApplicationErrorBoundary appName="BeatQ Merchant" homeHref="/operations">
      <AppQueryProvider>
        <AuthProvider surface="merchant">
          <PermissionProvider surface="merchant">
            <ThemeProvider>
              <ToastProvider connectivityToasts={false}>
                <RouterProvider router={router} />
              </ToastProvider>
            </ThemeProvider>
          </PermissionProvider>
        </AuthProvider>
      </AppQueryProvider>
    </ApplicationErrorBoundary>
  </StrictMode>,
);
